import React, { useState } from 'react';
import { VehicleStatus } from '../../types/vehicle';

interface BulkActionsProps {
  selectedVehicleIds: string[];
  onBulkStatusUpdate: (status: VehicleStatus) => void;
  onClearSelection: () => void;
  isLoading?: boolean;
}

const BulkActions: React.FC<BulkActionsProps> = ({
  selectedVehicleIds,
  onBulkStatusUpdate,
  onClearSelection,
  isLoading = false
}) => {
  const [selectedAction, setSelectedAction] = useState<string>('');

  const handleActionSubmit = () => {
    if (selectedAction && selectedAction !== '') {
      onBulkStatusUpdate(selectedAction as VehicleStatus);
      setSelectedAction('');
    }
  };

  if (selectedVehicleIds.length === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <span className="text-sm font-medium text-blue-900">
            {selectedVehicleIds.length} vehicle{selectedVehicleIds.length > 1 ? 's' : ''} selected
          </span>
          
          <div className="flex items-center space-x-2">
            <select
              value={selectedAction}
              onChange={(e) => setSelectedAction(e.target.value)}
              className="px-3 py-1 border border-blue-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              <option value="">Select action...</option>
              <option value={VehicleStatus.AVAILABLE}>Set to Available</option>
              <option value={VehicleStatus.MAINTENANCE}>Set to Maintenance</option>
              <option value={VehicleStatus.OUT_OF_SERVICE}>Set to Out of Service</option>
              <option value={VehicleStatus.RESERVED}>Set to Reserved</option>
            </select>
            
            <button
              onClick={handleActionSubmit}
              disabled={!selectedAction || isLoading}
              className="px-4 py-1 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Updating...' : 'Apply'}
            </button>
          </div>
        </div>
        
        <button
          onClick={onClearSelection}
          className="text-sm text-blue-600 hover:text-blue-800"
          disabled={isLoading}
        >
          Clear selection
        </button>
      </div>
    </div>
  );
};

export default BulkActions;